(function () {
  'use strict';

  var productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return;

  var productJsonEl = document.getElementById('ProductJson-' + productSection.getAttribute('data-section-id'));
  var productData = null;

  if (productJsonEl) {
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      productData = null;
    }
  }

  var lastVariantId = null;
  var mobileCarousel = productSection.querySelector(
    '.product__media-container.below-mobile.carousel.swiper'
  );
  var mobileGallery = mobileCarousel && mobileCarousel.querySelector('.product__media');
  var mobileSlides = mobileGallery
    ? Array.from(mobileGallery.querySelectorAll('.product__media-item[data-product-id]'))
    : [];

  function getVariantInput() {
    return (
      productSection.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]')
    );
  }

  function getVariantIdFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  function getVariantIdFromForm() {
    var input = getVariantInput();
    return input && input.value ? String(input.value) : null;
  }

  function getSelectedOptions() {
    var selectedOptions = [];
    var optionGroups = productSection.querySelectorAll(
      '[data-option-buttons], .product__option, .product-form__option, fieldset'
    );

    optionGroups.forEach(function (group) {
      var checkedInput = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');

      if (checkedInput && checkedInput.value) {
        selectedOptions.push(checkedInput.value);
      } else if (select && select.value) {
        selectedOptions.push(select.value);
      }
    });

    return selectedOptions;
  }

  function getVariantIdFromSelectedOptions() {
    if (!productData || !productData.variants) return null;

    var selectedOptions = getSelectedOptions();
    if (!selectedOptions.length) return null;

    var matchedVariant = productData.variants.find(function (variant) {
      return selectedOptions.every(function (optionValue, index) {
        return String(variant.options[index]) === String(optionValue);
      });
    });

    return matchedVariant ? String(matchedVariant.id) : null;
  }

  function getCurrentVariantId() {
    return (
      getVariantIdFromUrl() ||
      getVariantIdFromForm() ||
      getVariantIdFromSelectedOptions() ||
      productSection.getAttribute('data-current-product-id')
    );
  }

  function hideElement(el) {
    el.classList.add('hidden');
    el.style.display = 'none';
  }

  function showElement(el) {
    el.classList.remove('hidden');
    el.style.display = '';
  }

  function pauseHiddenVideos() {
    productSection.querySelectorAll('.product__media-item.hidden video').forEach(function (video) {
      try { video.pause(); } catch (e) {}
    });
  }

  function getDesktopGallery() {
    return productSection.querySelector('.product__media-container.above-mobile .product__media');
  }

  function getMobileGallery() {
    return productSection.querySelector('.product__media-container.below-mobile .product__media');
  }

  function renderMobileVariantSlides(variantId) {
    if (!mobileGallery || !mobileSlides.length) return false;

    var selectedSlides = [];

    mobileSlides.forEach(function (slide) {
      if (String(slide.getAttribute('data-product-id')) === variantId) {
        showElement(slide);
        selectedSlides.push(slide);
      } else {
        hideElement(slide);
      }
    });

    mobileSlides.forEach(function (slide) {
      if (slide.parentNode === mobileGallery) {
        mobileGallery.removeChild(slide);
      }
    });

    selectedSlides.forEach(function (slide) {
      mobileGallery.appendChild(slide);
    });

    return true;
  }

  function refreshMobileSwiper(attempt) {
    if (!mobileCarousel || !window.matchMedia('(max-width: 959px)').matches) return;

    attempt = attempt || 0;

    if (!mobileCarousel.swiper) {
      if (attempt < 60) {
        requestAnimationFrame(function () {
          refreshMobileSwiper(attempt + 1);
        });
      }
      return;
    }

    requestAnimationFrame(function () {
      var swiper = mobileCarousel.swiper;
      if (swiper.destroyed) return;

      swiper.update();
      swiper.slideTo(0, 0, false);
      swiper.updateSlidesClasses();

      if (swiper.pagination) {
        swiper.pagination.render();
        swiper.pagination.update();
      }

      if (swiper.updateAutoHeight) {
        swiper.updateAutoHeight(0);
      }
    });
  }

  function getThumbnailList() {
    return productSection.querySelector('.product-thumbnails__items');
  }

  function showDesktopMediaById(mediaId) {
    var desktopGallery = getDesktopGallery();
    if (!desktopGallery || !mediaId) return;

    desktopGallery.querySelectorAll('.product__media-item[data-media-item-id]').forEach(function (item) {
      hideElement(item);
    });

    var target = desktopGallery.querySelector('[data-media-item-id="' + CSS.escape(mediaId) + '"]');
    if (target) {
      showElement(target);
    }

    pauseHiddenVideos();
  }

  function setActiveThumbnail(thumbnailButton) {
    productSection.querySelectorAll('.product-thumbnails__item-link.active').forEach(function (thumb) {
      thumb.classList.remove('active');
    });

    if (thumbnailButton) {
      thumbnailButton.classList.add('active');
    }
  }

  function updateVariantGallery(variantId) {
    if (!variantId) return;

    variantId = String(variantId);

    if (variantId === lastVariantId) return;
    lastVariantId = variantId;

    productSection.setAttribute('data-current-product-id', variantId);

    var thumbnailList = getThumbnailList();
    var desktopGallery = getDesktopGallery();
    var mobileGallery = getMobileGallery();

    if (thumbnailList) {
      thumbnailList.querySelectorAll('.product-thumbnails__item[data-product-id]').forEach(function (thumbItem) {
        if (String(thumbItem.getAttribute('data-product-id')) === variantId) {
          showElement(thumbItem);
        } else {
          hideElement(thumbItem);
        }
      });
    }

    if (desktopGallery) {
      desktopGallery.querySelectorAll('.product__media-item[data-product-id]').forEach(function (mediaItem) {
        hideElement(mediaItem);
      });
    }

    if (mobileGallery && !renderMobileVariantSlides(variantId)) {
      mobileGallery.querySelectorAll('.product__media-item[data-product-id]').forEach(function (mediaItem) {
        if (String(mediaItem.getAttribute('data-product-id')) === variantId) {
          showElement(mediaItem);
        } else {
          hideElement(mediaItem);
        }
      });
    }

    var firstVisibleThumb = productSection.querySelector(
      '.product-thumbnails__item[data-product-id="' + CSS.escape(variantId) + '"]:not(.hidden) .product-thumbnails__item-link'
    );

    if (firstVisibleThumb) {
      var firstMediaId = firstVisibleThumb.getAttribute('data-thumbnail-id');
      setActiveThumbnail(firstVisibleThumb);
      showDesktopMediaById(firstMediaId);
    } else if (desktopGallery) {
      var firstMedia = desktopGallery.querySelector(
        '.product__media-item[data-product-id="' + CSS.escape(variantId) + '"]'
      );
      if (firstMedia) {
        showElement(firstMedia);
      }
    }

    refreshMobileSwiper();

    pauseHiddenVideos();
    productSection.dispatchEvent(new CustomEvent('gallery:media-changed'));
  }

  // Thumbnail click delegation (scoped to product section)
  productSection.addEventListener('click', function (event) {
    var paginationButton = event.target.closest(
      '.product__media-pagination .swiper-pagination-bullet'
    );

    if (paginationButton) {
      var mobileSwiperEl = productSection.querySelector(
        '.product__media-container.carousel.swiper'
      );
      var paginationButtons = Array.from(
        paginationButton.parentElement.querySelectorAll('.swiper-pagination-bullet')
      );
      var targetIndex = paginationButtons.indexOf(paginationButton);

      if (mobileSwiperEl && mobileSwiperEl.swiper && targetIndex > -1) {
        event.preventDefault();
        event.stopPropagation();
        mobileSwiperEl.swiper.slideTo(targetIndex, 400);
      }
      return;
    }

    var thumbnailButton = event.target.closest('[data-product-thumbnail]');
    if (!thumbnailButton) return;

    var thumbItem = thumbnailButton.closest('.product-thumbnails__item[data-product-id]');
    if (!thumbItem || thumbItem.classList.contains('hidden')) return;

    var mediaId = thumbnailButton.getAttribute('data-thumbnail-id');
    setActiveThumbnail(thumbnailButton);
    showDesktopMediaById(mediaId);
    productSection.dispatchEvent(new CustomEvent('gallery:media-changed'));
  });

  function scheduleUpdate() {
    requestAnimationFrame(function () {
      updateVariantGallery(getCurrentVariantId());
    });
  }

  // Scoped change listener on the product section
  productSection.addEventListener('change', scheduleUpdate);

  // Variant change custom events
  document.addEventListener('variant:change', function (event) {
    var variantId = event.detail && event.detail.variant && event.detail.variant.id;
    updateVariantGallery(variantId || getCurrentVariantId());
  });

  document.addEventListener('product:variant-change', function (event) {
    var variantId = event.detail && event.detail.variant && event.detail.variant.id;
    updateVariantGallery(variantId || getCurrentVariantId());
  });

  // MutationObserver fallback for variant pickers that only update the hidden input
  var variantInput = getVariantInput();
  if (variantInput) {
    var observer = new MutationObserver(function () {
      updateVariantGallery(String(variantInput.value));
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    // Also watch for programmatic .value sets (not caught by MutationObserver)
    var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (descriptor && descriptor.set) {
      var originalSetter = descriptor.set;
      Object.defineProperty(variantInput, 'value', {
        get: function () { return descriptor.get.call(this); },
        set: function (val) {
          originalSetter.call(this, val);
          updateVariantGallery(String(val));
        },
        configurable: true
      });
    }
  }

  // Initial load
  lastVariantId = null;
  updateVariantGallery(getCurrentVariantId());
})();
